<tui-scrollbar class="chat-administrations-list">
  <div class="chat-administrations-list__header">
    <chat-details-item
      [icon]="'users'"
      [label]="'components.internalMessenger.labels.administrations' | translate"
      [actions]="headerActions"
    ></chat-details-item>
  </div>

  <div class="chat-administrations-list__body">
    <div class="list">
      <ng-container *ngIf="!!administrations; else tmpLoading">
        <ng-container *ngIf="administrations.length; else tmpNoData">
          <ng-container *ngFor="let administration of administrations">
            <chat-members-list-item
              class="list-item"
              [routerLink]="'/association-users/' + administration.userId"
              routerLinkActive="list-item_selected"
              [member]="administration"
              [actions]="itemActions"
            ></chat-members-list-item>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>

    <ng-template #tmpLoading>
      <app-skeleton-wrapper [loading]="true"></app-skeleton-wrapper>
    </ng-template>

    <ng-template #tmpNoData>
      <div class="no-data">
        <p>{{ 'components.internalMessenger.labels.noData' | translate }}</p>
      </div>
    </ng-template>
  </div>
</tui-scrollbar>
